import React from "react";
import {Menu, MenuItem, Stack, TextField} from "@mui/material";
import StyledTreeItem from "../general/tree/StyledTreeItem";
import RegionLabel from "./RegionLabel";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import ContextMenuItemLabel from "../general/menuItem/ContextMenuItemLabel";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import LabelViewer from "./Annotation/LabelViewer";
import {TEXT_NODE_VIEW} from "./useTree";


export default function Region(props) {
    const {
        node,
        toggleEdit,
        recalculateLineBB,
        onChangeViewMode,
        onSave,
        onAnnotationChange,
        children,
        ...other
    } = props;
    const {t} = useTranslation("common");
    const {enqueueSnackbar} = useSnackbar();
    // Context menu state
    const initialState = {
        mouseX: null,
        mouseY: null,
    };
    const [state, setState] = React.useState(initialState);

    const handleContextMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setState({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
    };

    const handleCloseContextMenu = () => {
        setState(initialState);
    };

    const copy = (value) => {
        navigator.clipboard.writeText(value).then(function () {
            /* clipboard successfully set */
            enqueueSnackbar(t("main.components.dataViewer.notification.copy"), {variant: "success"});
        }, function () {
            /* clipboard write failed */
            enqueueSnackbar(t("main.components.dataViewer.notification.copyfailure"), {variant: "error"});
        });
    }

    const handleCopy = () => {
        copy(node.data.cachedContent);
        handleCloseContextMenu();
    }

    // Render

    const treeLabel = <>
        <RegionLabel
            label={node.label}
            editable={node.editable}
            role={props.role}
            toggleEdit={() => {
                toggleEdit();
            }}
            onChangeViewMode={onChangeViewMode}
            onSave={() => {
                onSave();
            }}
        />
        <Menu
            open={state.mouseY !== null}
            onClose={handleCloseContextMenu}
            anchorReference="anchorPosition"
            anchorPosition={
                state.mouseY !== null && state.mouseX !== null
                    ? {top: state.mouseY, left: state.mouseX}
                    : undefined
            }
        >
            <MenuItem onClick={handleCopy}>
                <ContextMenuItemLabel
                    icon={<ContentCopyIcon fontSize="small"/>}
                    shortcut="Ctrl+c"
                >
                    {t("main.components.dataViewer.contextMenu.copy")}
                </ContextMenuItemLabel>
            </MenuItem>
            {node.editable && (
                <MenuItem onClick={() => recalculateLineBB()}>
                    <ContextMenuItemLabel
                        icon={<AutorenewIcon fontSize="small"/>}
                    >
                        {t("main.components.dataViewer.contextMenu.recalculate")}
                    </ContextMenuItemLabel>
                </MenuItem>
            )}
        </Menu>
    </>;

    return (
        <StyledTreeItem
            {...other}
            onContextMenu={handleContextMenu}
            label={treeLabel}
        >
            {node.viewMode === TEXT_NODE_VIEW.TREE && children}
            {node.viewMode === TEXT_NODE_VIEW.TEXT && <Stack>
                <TextField multiline fullWidth focused={false} value={node.data.cachedContent}/>
            </Stack>}
            {node.viewMode === TEXT_NODE_VIEW.LABEL && (
                <LabelViewer text={node.data} onAnnotationChange={onAnnotationChange}/>
            )}
        </StyledTreeItem>
    );
}

Region.propTypes = {
    node: PropTypes.object.isRequired,
    toggleEdit: PropTypes.func.isRequired,
    recalculateLineBB: PropTypes.func.isRequired,
    onChangeViewMode: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onAnnotationChange: PropTypes.func.isRequired
}